import AppraisalApi from './Appraisal';
import AuthApi from './AuthApi';

class Api {
  appraisal = new AppraisalApi();

  auth = new AuthApi();
}

export default Api;
